module.exports = __webpack_public_path__ + "img/user.e81becb0.png";